import React, { useContext } from "react";
import styled from "styled-components";

import { PlatformIcon } from "@/entities/accounts/components/plaform-icon/plaform-icon";

import { postPlatformsConfig } from "./../postPlatforms.config";
import youtubeIconUtils from "utils/youtube-icon-utils";
import { PlatformOptionsCardContext } from "../components/platform-options-card";

const PlatformUsage = ({
  platforms,
  field,
  selectedPlatform,
  className = "",
  variant = "default",
}) => {
  const isGroupedByPlatform = useContext(PlatformOptionsCardContext);

  if (selectedPlatform !== "LINKED" || isGroupedByPlatform) {
    return <></>;
  }

  return (
    <Platforms className={className} $compact={variant === "other-options"}>
      {platforms.map((platform) => {
        const fields = postPlatformsConfig[platform.TYPE].fields;
        const type = youtubeIconUtils.resolveYtRedIcon(platform.NAME);
        if (!fields.includes(field)) {
          return "";
        }

        return (
          <PlatformIcon
            key={`${field}-${platform.TYPE}`}
            className={variant === "other-options" ? "" : "mr-2"}
            type={type}
          />
        );
      })}
    </Platforms>
  );
};

const Platforms = styled.div`
  height: ${(props) => (props.$compact ? "16px" : "19px")};
  display: flex;
  align-items: center;
  gap: ${(props) => (props.$compact ? "4px" : "0")};

  ${PlatformIcon} {
    width: ${(props) => (props.$compact ? "16px" : "15px")};
    height: ${(props) => (props.$compact ? "16px" : "15px")};
  }
`;

export default PlatformUsage;
